import type { FireflyRuntime } from "@squide/firefly";
import { NavigationItemLabel } from "../i18n/NavigationItemLabel.tsx";
import type { LocalizedText } from "./layoutHandles.ts";
import type { LinkAdditionalProps, LinkIcon } from "./link.ts";
import { CREATE_MENU_ID } from "./menuIds.ts";

export interface CreateMenuItemOptions {
    id: string;
    label: LocalizedText;
    icon: LinkIcon;
    to: string;
    priority: number;
    isExternal?: boolean;
}

export function registerCreateMenuItem(runtime: FireflyRuntime, { id, label, icon, to, priority, isExternal }: CreateMenuItemOptions) {
    runtime.registerNavigationItem(
        {
            $id: `${CREATE_MENU_ID}-${id}`,
            $priority: priority,
            $label: <NavigationItemLabel {...label} />,
            to,
            $additionalProps: { icon, isExternal } satisfies LinkAdditionalProps
        },
        { menuId: CREATE_MENU_ID }
    );
}
